import {z} from 'zod'

export const quantitySchema = z.object({
  quantity: z.discriminatedUnion('type', [
    z.object({
      type: z.literal('volume'),
      volume: z.number(),
      quantityUom: z.string()
    }),
    z.object({
      type: z.literal('fullLoads'),
      fullLoads: z.number().int().positive(),
      minQuantity: z.number().positive(),
      maxQuantity: z.number().positive(),
      quantityUom: z.string()
    })
  ])
})
